// Get all of the scripts
let scripts = document.getElementsByTagName("script");

// Search for the nmcom script
let i = 0;
let nmcomScript = null;
while(!nmcomScript && i < scripts.length - 1) {
    let script = scripts[i];
    let src = script.getAttribute('src') || "";

    // search for nmx-template.js
    if (src.indexOf("js/nmx-template.js") > -1) {
        nmcomScript = script;
    }

    i++;
}

export const ASSETS_URL = "";
export const APP_NAME = (nmcomScript && nmcomScript.getAttribute("nmx-app-name"));
export const APP_VERSION = (nmcomScript && nmcomScript.getAttribute("nmx-app-version"));
